module.exports = {"hos":{"header":{"signin":"התחברות","signup":"יצירת חשבון"}},"meta":{"lead":"עורך טקסט משותף"}};